module.exports = __webpack_public_path__ + "img/belize.e36ae432.svg";